import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { selectSessionInfo } from 'services/session/session.selectors';
import { selectUserProfile } from 'services/user/user.selectors';
import { AppChannel } from 'utils/config.config';
import { getApiUrl } from 'utils/functions/sandsiv';
import { triggerSurvey, TriggerType } from './survey-utils';

export const SandsivSurveyIdPS = {
  GiveFeedback: 14,
  SelfExclusion: 16,
} as const;

type SandsivSurveyIdPSItaType =
  (typeof SandsivSurveyIdPS)[keyof typeof SandsivSurveyIdPS];

export function useSandsivTriggerPs() {
  const sessionInfo = useSelector(selectSessionInfo);
  const userProfile = useSelector(selectUserProfile);

  const channel =
    sessionInfo.channel ?? AppChannel.PortaleWebFullResponsiveWwwSisalIt;

  const billCode = userProfile.billCode;
  const apiUrl = getApiUrl();

  return useCallback(
    (
      surveyId: SandsivSurveyIdPSItaType,
      triggerType: TriggerType,
      ipAddress?: string,
    ) =>
      triggerSurvey(
        apiUrl,
        surveyId,
        channel,
        billCode,
        triggerType,
        ipAddress,
      ),
    [apiUrl, channel, billCode],
  );
}
